import type { GenericObject, OfferIncentives, Terms } from '@makemydeal/dr-platform-types';
import type { AnyAction } from 'redux';
import { initialState } from './initialState';

export const termsPassthroughReducer = (state: Terms = initialState.terms, _action: AnyAction) => {
    return state;
};

export const incentivesPassthroughReducer = (state: OfferIncentives = initialState.incentives, _action: AnyAction) => {
    return state;
};

export const previousTerms = (state: GenericObject = initialState.previousTerms, _action: AnyAction) => {
    return state;
};
